import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { useTranslation } from '../../translations';
import './index.css';

const Partners = () => {
  const { language } = useLanguage();
  const t = useTranslation(language);

  return (
    <section className="partners" id="partners">
      <div className="container">
        <div className="partners-header">
          <span className="section-badge">{t.partners.badge}</span>
          <h2>{t.partners.title}</h2>
          <p className="partners-intro">{t.partners.intro}</p>
        </div>

        <div className="partners-grid">
          {(t.partners.list || []).map((partner, index) => (
            <div className="partner-card" key={index}>
              <div className="partner-logo">
                {partner.logo ? (
                  <img src={partner.logo} alt={partner.name} className="partner-logo-img" />
                ) : (
                  <span className="partner-monogram">{partner.name.charAt(0)}</span>
                )}
              </div>
              <div className="partner-body">
                <h3>{partner.name}</h3>
                {partner.category && (
                  <span className="partner-category">{partner.category}</span>
                )}
                <p className="partner-desc">{partner.description}</p>
              </div>
            </div>
          ))}
        </div>

        {t.partners.note && <p className="partners-note">{t.partners.note}</p>}
      </div>
    </section>
  );
};

export default Partners;
